<template>
  <div
    class='theme-textarea'
    :class="{
      'theme-input__field-holder--error': !!errors.has(newName),
      'theme-input__field-holder--focused': isFocused,
    }"
    data-vv-value-path='model'
    :data-vv-as='label'
  >
    <label v-if='label' class='theme-input__label'>
      {{ label }}
      <span v-if='isRequired' class='theme-input__label-asterisk'>*</span>
    </label>
    <textarea
      v-model='model'
      :name='name'
      :rows='rows'
      class='theme-input min-h-[60px] max-h-[500px]'
      :class="{'theme-textarea--gray': gray}"
      :disabled='disabled'
      :placeholder='placeholder'
      @change="$emit('input', model)"
      @blur="
        $emit('blur', $event);
        isFocused = false;
      "
      @focus="
        $emit('focus', $event);
        isFocused = true;
      "
    />
    <div class='theme-input__error-text' v-if='errors.has(newName)'>
      {{ errors.first(newName) }}
    </div>
  </div>
</template>

<script>
  import field from '../admin/mixins/field';

  export default {
    data() {
      return {
        isFocused: false,
      };
    },
    mixins: [field],
    props: {
      rows: {
        default: '4',
        type: String,
      },
      placeholder: {
        default: '',
        type: String,
      },
      gray: {
        default: false,
        type: Boolean,
      },
      isRequired: {
        default: false,
        type: Boolean,
      },
    },
  };
</script>